import { Quote } from 'components/Quote'
import { ReactNode } from 'react'

export const content_sport: {
  title: string
  author: string
  autorBio: string
  content: ReactNode
  link: number
}[] = [
  {
    title: 'Ist Roger Federer zu spät zurückgetreten?',
    author: 'Simon Graf',
    autorBio: '97577558/simon-graf',
    content: (
      <>
        <p>
          Leider ja. Die letzten zweieinhalb Jahre waren quälend für seine Fans
          und bestimmt auch für ihn selbst. Das rechte Knie begann ihn schon
          2019 zu plagen, im Februar 2020 liess er es operieren, es folgten zwei
          weitere Eingriffe an selber Stelle. Federer kämpfte verbissen um eine
          Rückkehr, doch sein Problemknie schwoll immer wieder an, wenn er es zu
          sehr belastete. Und ohne seine Agilität fehlte ihm auf dem Court die
          Magie.
        </p>
        <Quote>Federer schob die definitive Entscheidung vor sich her.</Quote>
        <p>
          Schon Monate bevor er Mitte September 2022 seinen Rücktritt erklärte,
          war in seinem innersten Zirkel klar, dass es nichts mehr werden würde
          mit einem Comeback. Doch Federer schob die definitive Entscheidung vor
          sich her. Wäre er nach seiner zweiten Knie-OP im Sommer 2020
          zurückgetreten, wäre ihm einiges erspart geblieben. Doch im Nachhinein
          ist man immer schlauer. Und natürlich spielte es bei ihm hinein, dass
          er 2017 nach einer Operation am linken Knie erfolgreich zurückgekehrt
          war und nochmals drei Grand-Slam-Titel gewonnen hatte. «Ich muss nicht
          auch noch kitschig abtreten», sagte er damals nach seinem völlig
          unerwarteten Triumph am Australian Open, als ich ihn auf der
          Lenzerheide zum Interview traf.
        </p>
        <p>
          Es war am Ende aber doch recht kitschig, wie er am Laver-Cup im
          letzten September sein letztes Doppel an der Seite seines ewigen
          Rivalen Rafael Nadal spielte und danach kein Auge trocken blieb. Doch
          ein nüchterner Abschied hätte zu ihm, der über die Jahre so viele
          Menschen berührte, auch nicht gepasst.
        </p>
      </>
    ),
    link: 155887396817,
  },
  {
    title: 'War Katar 2022 die schlechteste WM aller Zeiten?',
    author: 'Moritz Marthaler',
    autorBio: '51567324/moritz-marthaler',
    content: (
      <>
        <p>
          Jede Fussball-Weltmeisterschaft nistet sich auf ihre Weise im
          sporthistorischen Gedächtnis eines Landes ein. Die WM 2014? Für die
          Deutschen ein Sommermärchen, für die Brasilianer ein Trauma. Die
          Engländer haben ihre WM von 1966, bei der sie ihren bisher einzigen
          grossen Titel gewannen. Die Franzosen haben 1998 und den Triumph im
          eigenen Land, die Argentinier 1986 und den Moment, in dem die Welt
          erkannte, dass Diego Armando Maradona als einer der grössten
          Fussballer in die Geschichte eingehen würde.
        </p>
        <p>
          Auch die WM von Katar hat gewissen Nationen eine Erzählung
          hinterlassen, der Schweiz zum Beispiel jene der höchsten Niederlage an
          einer WM seit 1966. Daneben wird sie besonders in Erinnerung bleiben:
          als Winter-WM mit dem Final eine Woche vor Heiligabend, als Absurdum
          im Sportkalender, als Fussball-Traditionsanlass an einem Ort ohne
          Fussballtradition.
        </p>
        <Quote>
          War die Vergabe nach Katar ein Fehler? Ja, auch wenn es an der Zeit
          war, das Turnier einmal in die arabische Welt zu vergeben.
        </Quote>
        <p>
          So zumindest denkt man in Europa. Denn jede WM ist auch ein globaler
          Meinungsabgleich. Dass ob der WM in Katar nicht überall in der
          Fussballwelt die Nase gerümpft wird, zeigen die über 50’000
          Argentinien-Fans vor Ort und die Millionen zu Hause auf den Strassen,
          die, südlich des Äquators, zum ersten Mal ein Turnier in ihrem Sommer
          geniessen können.
        </p>
        <p>
          Die politische Dimension dieser WM ist grösser als sonst. Sie kostete
          mit fast 220 Milliarden Dollar unvorstellbar viel Geld – die Welt
          weiss jetzt Bescheid über die Energiereserven und den Reichtum des
          Emirats. Gastarbeiter liessen auf den Baustellen für die Stadien ihr
          Leben – die Welt weiss jetzt Bescheid über ihre hundsmiserablen
          Bedingungen im am Golf üblichen Kafala-System. Die Rechte von Frauen
          und Homosexuellen sind in Katar stark eingeschränkt – die Welt weiss
          nun Bescheid über die wahhabistische Auslegung des Islam. Die Vergabe
          an Katar vor 12 Jahren war mutmasslich gekauft – spätestens jetzt weiss die Welt
          Bescheid, wie korrupt das System rund um den Weltfussballverband Fifa
          ist.
        </p>
        <p>
          Wird durch die WM in Katar vor Ort alles besser? Nein, aber auch
          bestimmt nicht schlechter. War die Vergabe nach Katar ein Fehler? Ja,
          auch wenn es an der Zeit war, das Turnier einmal in die arabische Welt
          zu vergeben. Und war Katar die schlechteste WM aller Zeiten? Sie fiel
          fussballerisch weder auf noch ab, war politisch problematisch, wurde
          gesellschaftlich kontrovers diskutiert. Aber in der Rückschau wird es
          eine Fussball-WM wie jede andere vor ihr: Sie sorgte für
          wirtschaftlichen Umsatz und sportliche Unterhaltung, vielleicht löste
          sie Probleme, genau so, wie sie Probleme hinterlassen wird. Die
          Empörung darüber kam indes Jahre zu spät.
        </p>
      </>
    ),
    link: 826596684911,
  },
]
